import { EnvioDTO } from "@DTOS";
import { formatDate } from "@angular/common";
import { TipoEnviosEnum } from "@shared/enums";

export const obtenerDateDiferenciaEnTexto = (fecha: Date) => {
    const ahora = new Date();

    const diferencia = ahora.getTime() - fecha.getTime();
    const diferenciaDias = Math.trunc(diferencia / (1000 * 3600 * 24));

    if (diferenciaDias === 0) {
        return "Hoy";
    }

    if (diferenciaDias < 7) {
        return `Hace ${diferenciaDias === 1 ? "un" : diferenciaDias} ${diferenciaDias === 1 ? "día" : "días"}`;
    }

    const diferenciaSemanas = Math.trunc(diferenciaDias / 7);

    if (diferenciaSemanas < 4) {
        return `Hace ${diferenciaSemanas === 1 ? "una" : diferenciaSemanas} ${diferenciaSemanas === 1 ?
            "semana" : "semanas"}`;
    }

    const diferenciaMeses = Math.trunc(diferenciaSemanas / 4);

    if (diferenciaMeses < 12) {
        return `Hace ${diferenciaMeses === 1 ? "un" : diferenciaMeses} ${diferenciaMeses === 1 ? "mes" : "meses"}`;
    }

    const diferenciaYears = Math.trunc(diferenciaMeses / 12);

    return `Hace ${diferenciaYears === 1 ? "un" : diferenciaYears} ${diferenciaYears === 1 ? "año" : "años"}`;
};

export const obtenerFechaAmigableEnvio: (envio: EnvioDTO) => string = envio => {
    const time = formatDate(envio.fechaEnvio, "HH:mm", "es-AR");
    const date = formatDate(envio.fechaEnvio, "dd MMM", "es-AR").substring(0, 6).toUpperCase();
    const weekday = formatDate(envio.fechaEnvio, "EEE", "es-AR").substring(0, 3).toUpperCase();

    return envio.tipo === TipoEnviosEnum.STICKY_ALWAYS_ANYTIME ? "SIEMPRE" :
        (envio.tipo === TipoEnviosEnum.QMP ? "QMP" :
            (envio.tipo === TipoEnviosEnum.STICKY_WEEK_DAY ? weekday :
                (envio.tipo === TipoEnviosEnum.STICKY_WEEK_DAYTIME ? weekday + " " + time :
                    (envio.tipo === TipoEnviosEnum.STICKY_SINGLE_DAY ? weekday + " " + date :
                        (envio.tipo === TipoEnviosEnum.NOT_STICKY_DATETIME ? date + " " + time :
                            "")))));
};
